import React, { Component } from "react";
import {CSVLink} from 'react-csv';
import "./style.scss";
import Table from '../../../../components/table';
import { connect } from "react-redux";
import { ACTIONS_PLAYER, GetPlayerPerformance, convertDataPlayerPerformancePitcher, convertDataPlayerPerformanceBatter } from './../../../../actions/player-performance';
import Loading from "../../../../components/loading";

class PerformanceByYear extends Component {

    constructor(props) {
        super(props);
        this.state = {
            listPlayerPerformanceBatter : [],
            listPlayerPerformancePitcher : [],
            showLoading: false,
            isPitcherOrBatter: true,
            listCsv: []
        }
    }

    componentDidMount() {
        this.setState({showLoading: true});
        let tables = document.getElementsByClassName('wrap-table');
        for (let i = 0; i < tables.length; i++) {
            let itemCenter = tables[i].getElementsByClassName('item-center');
            for (let i = 0; i < itemCenter.length; i++) {
                if (i === itemCenter.length - 1) {
                    let td = itemCenter[i].getElementsByClassName('border-0');
                    td[0].setAttribute('colspan', '2');
                }
            }
        }

        this.props.GetPlayerPerformance(this.props.match.params.id, 0);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (nextProps) {
            if (nextProps.status === ACTIONS_PLAYER.GET_HEADER_PLAYER_PERFORMANCE_SUCCESS) {
                const batter = convertDataPlayerPerformanceBatter(nextProps.response.batter) || [];
                const pitcher = convertDataPlayerPerformancePitcher(nextProps.response.pitcher) || [];

                const batterCsv = [];
                const pitcherCsv = [];

                batter.forEach(value => {
                    batterCsv.push(value.item.map(item => item.text || item.teamName || ''))
                });
                pitcher.forEach(value => {
                    pitcherCsv.push(value.item.map(item => item.text || item.teamName || ''))
                });

                this.setState({
                    listPlayerPerformanceBatter: batter,
                    listPlayerPerformancePitcher: pitcher,
                    showLoading: false,
                    listCsv: [
                        [this.props.titlePitching.text],
                        this.props.headerPitching,
                        ...pitcherCsv,
                        [this.props.titleHitting.text],
                        this.props.headerHitting,
                        ...batterCsv
                    ]
                })
            }
        }
    }

    openTab(e, tabName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("tabcontent");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
        }
        tablinks = document.getElementsByClassName("tablinks");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
        }
        document.getElementById(tabName).style.display = "block";
        e.currentTarget.className += " active";
        this.setState({showLoading: true});
        if (tabName === 'pitcher') {
            this.props.GetPlayerPerformance(this.props.match.params.id, 0);
            this.setState({isPitcherOrBatter :true});
        } else {
            this.setState({isPitcherOrBatter :false});
            this.props.GetPlayerPerformance(this.props.match.params.id, 1);
        }
    }

    render() {
		const { history } = this.props;
        return (
            <div className="year">
                <div className="year-control">
                    <div className="left">
                        <h2 className="title">過去シーズン成績</h2>
                    </div>
                    <div className="right">
                        <div className="block-button">
                            <CSVLink className={'csv-download'}
                                     data={this.state.listCsv}
                                     filename={'performance-by-year.csv'}>
                                CSVダウンロード
                            </CSVLink>
                        </div>
                    </div>
                </div>
                <div className="year-content">
                    <div id="pitcher" className="tabcontent">
                        <Table
                            header={this.props.headerPitching}
                            showPagination={false}
                            showCheckbox={false}
                            showSearch={false}
                            itemOfPage={this.state.listPlayerPerformancePitcher}
                            isShowOptionTable={false} titleTable={this.props.titlePitching}
                            openLink={(val) => {
                                history.push(val.url)
                            }}
                            />
                        <Table
                            header={this.props.headerHitting}
                            showPagination={false}
                            showCheckbox={false}
                            showSearch={false}
                            itemOfPage={this.state.listPlayerPerformanceBatter}
                            isShowOptionTable={false}
                            titleTable={this.props.titleHitting}
                            openLink={(val) => {
                                history.push(val.url)
                            }}
                            />
                    </div>

                    <div id="batter" className="tabcontent">
                        <Table
                            header={this.props.headerPitching}
                            showPagination={false}
                            showCheckbox={false}
                            showSearch={false}
                            itemOfPage={this.state.listPlayerPerformancePitcher}
                            isShowOptionTable={false} titleTable={this.props.titlePitching}
                            openLink={(val) => {
                                history.push(val.url)
                            }}
                            />
                        <Table
                            header={this.props.headerHitting}
                            showPagination={false}
                            showCheckbox={false}
                            showSearch={false}
                            itemOfPage={this.state.listPlayerPerformanceBatter}
                            isShowOptionTable={false}
                            titleTable={this.props.titleHitting}
                            openLink={(val) => {
                                history.push(val.url)
                            }}
                            />
                    </div>
                </div>

                <Loading show={this.state.showLoading} />
            </div>
        )
    }
}

const mapStateToProps = ({ players }) => {
    return {
        titleHitting: players.titleHitting,
        headerHitting: players.headerHitting,
        dataHitting: players.dataHitting,
        titlePitching: players.titlePitching,
        headerPitching: players.headerPitching,
        dataPitching: players.dataPitching,
        status: players.status,
        response: players.response
    };
}

const mapDispatchToProps = dispatch => {
    return {
        GetPlayerPerformance: (playerId, is_farm) => {
            dispatch(GetPlayerPerformance(playerId, is_farm))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure : false })(PerformanceByYear);
